import { render, staticRenderFns } from "./SubTable.vue?vue&type=template&id=9b043a14&scoped=true&"
import script from "./SubTable.vue?vue&type=script&lang=ts&"
export * from "./SubTable.vue?vue&type=script&lang=ts&"
import style0 from "./SubTable.vue?vue&type=style&index=0&id=9b043a14&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b043a14",
  null
  
)

export default component.exports